import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

import defaultColor from './defaultColor';

export default function PaintbrushIcon(props) {
  const color = props.color === 'secondary' ? '#b1b1b1' : props.color;
  return <SvgIcon {...props} viewBox="0 0 14 14" fill="none">
    <path id="Vector 93" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M1.6539 7.43957c1.53854 -1.53854 3.4617 -1.1539 4.61561 0 1.1539 1.1539 1.53853 3.07703 0 4.61563C4.73097 13.5937 2.47058 13.7675 0.5 13.2091c1.51461 -1.5146 -0.5216643 -4.09397 1.1539 -5.76953Z"
          strokeWidth="1"></path>
    <path id="Subtract" stroke={color || defaultColor} fill="none" strokeLinecap="round" strokeLinejoin="round"
          d="M5.28418 6.73953c0.36406 0.17403 0.69833 0.41328 0.98509 0.70004 0.40526 0.40526 0.71563 0.90541 0.88113 1.45046 2.00107 -1.25483 3.8504 -2.63502 5.5826 -4.19094 1.0225 -0.91842 1.0094 -2.49862 0.0376 -3.47046 -0.9529 -0.95287 -2.4979 -0.989083 -3.41597 -0.0026 -1.55982 1.67613 -2.90267 3.48662 -4.07045 5.5135Z"
          strokeWidth="1"></path>
  </SvgIcon>
}
